import barba from '@barba/core';

const navbarToggle = () => {
    $('.navbar-toggler').each(function() {
      $(this).toggleClass( 'collapsed' )
    });
    $('.collapse').slideToggle().toggleClass('active');
}

const menuScroll = () => {
    if(window.innerWidth < 767) {
        if($('.collapse').hasClass('active')) {
            window.scroll_position = $(window).scrollTop();
            $('body')
                .css('position', 'fixed')
                .css('overflow', 'hidden')
                .css('width', '100%');
        } else {
            $('body')
                .css('position', '')
                .css('overflow', '')
                .css('width', 'auto');
            $(window).scrollTop(window.scroll_position);
        }
    }
}

$(document).on( 'click', '.navbar-toggler', function() {
    navbarToggle();
    menuScroll();
});


barba.hooks.after(() => {
    $('body')
        .css('position', '')
        .css('overflow', '')
        .css('width', 'auto');
});
